module.exports = __webpack_public_path__ + "static/media/skila-bg_img-01-1-pod_600px_width-0_1-@3x.8f6c5a3d.png";